export const HERO_LOOP_PAD = 2

export interface HeroLoopTile<T> {
    tile: T
    logical: number
    key: string
}

export function heroPlainRender<T>(tiles: T[]): HeroLoopTile<T>[] {
    return tiles.map((tile, logical) => ({ tile, logical, key: `r${logical}` }))
}

export function heroLoopRender<T>(tiles: T[]): HeroLoopTile<T>[] {
    const base = heroPlainRender(tiles)
    const n = base.length
    const tail = base.slice(n - HERO_LOOP_PAD).map((w, i) => ({ ...w, key: `t${i}` }))
    const head = base.slice(0, HERO_LOOP_PAD).map((w, i) => ({ ...w, key: `h${i}` }))
    return [...tail, ...base, ...head]
}

export function heroLoopLogical(rendered: number, n: number): number {
    return (((rendered - HERO_LOOP_PAD) % n) + n) % n
}

// Snap a position that drifted into the clone padding back onto its real twin.
export function heroLoopAnchor(rendered: number, n: number): number {
    let pos = rendered
    while (pos < HERO_LOOP_PAD) pos += n
    while (pos > HERO_LOOP_PAD + n - 1) pos -= n
    return pos
}
